<template>
  <div class="type">
    <el-dialog :close-on-click-modal="false"
      title="评论详情"
      :visible.sync="addProDialogVisible"
      :before-close="addProHandleClose"
      width="720px"
      center
    >
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleFormclass" label-width="100px" class="demo-ruleForm">
          <el-form-item label="昵称：" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="评论时间：" prop="name">
            <el-input v-model="ruleForm.createtime"></el-input>
          </el-form-item>
          <el-form-item label="评论内容：" prop="name">
            <div class="clear">
              <el-input v-model="ruleForm.content" type="textarea" ></el-input>
            </div>
          </el-form-item>
          <div v-if="ruleForm.img1||ruleForm.img2||ruleForm.img3||ruleForm.img4">
            <el-form-item label="评论图：" prop="name">
              <div class="imgs">
                <img :src="ruleForm.img1" alt="" v-if="ruleForm.img1">
                <img :src="ruleForm.img2" alt="" v-if="ruleForm.img2">
                <img :src="ruleForm.img3" alt="" v-if="ruleForm.img3">
                <img :src="ruleForm.img4" alt="" v-if="ruleForm.img4">
              </div>
            </el-form-item>
          </div>
        </el-form>
        <div class="button">
          <div @click="zhanshi0">暂不展示</div>
          <div @click="zhanshi">展示</div>
        </div>
      </div>
     </el-dialog>
  </div>
</template>
<script>
import {Message} from "element-ui"
    export default{
      data(){
        return{
          addProDialogVisible:false,
          ruleForm:{
          },
          rules:{
          },
          id:''
        }
      },
      methods:{
        zhanshi0(){
          let data = {
            id:this.id,
            shenhestatus:3,
            token:window.sessionStorage.getItem('Token')
          }
          this.MethodPost(
            "http://jhyapi.softykt.cn/member/member/evaluateAudit",
            data
          ).then((res) => {
            if(res.data.code=='666'){
              Message.success('不展示成功')
              this.addProDialogVisible = false
              this.$emit('close')
            }else{
              Message.error(res.data.msg)
            }
          })
        },
        zhanshi(){
          let data = {
            id:this.id,
            shenhestatus:2,
            token:window.sessionStorage.getItem('Token')
          }
          this.MethodPost(
            "http://jhyapi.softykt.cn/member/member/evaluateAudit",
            data
          ).then((res) => {
            if(res.data.code=='666'){
              Message.success('展示成功')
              this.addProDialogVisible = false
              this.$emit('close')
            }else{
              Message.error(res.data.msg)
            }
          })
        },
        pxFn(row){
          this.addProDialogVisible = true
          this.id = row.id
          let data  = {
            id:row.id,
            token:window.sessionStorage.getItem('Token')
          }
          this.MethodPost(
            "http://jhyapi.softykt.cn/member/member/evaluateDetail",
            data
          ).then((res) => {
            if(res.data.code=='666'){
              this.ruleForm = res.data.detail
              this.ruleForm.name = row.nickname
            }
          })
        },
        addProHandleClose(){
          this.addProDialogVisible = false
          this.$emit('close')
        },
      }
    }
</script>

<style scoped lang="less">
::v-deep .el-dialog__body{
  padding: 2rem 0 !important;
  border-top: 1px solid #E5E5EA;
}
.content{
  padding: 0 2rem 2rem 2rem;
  box-sizing: border-box;
  ::v-deep .el-select{
    width: 100%;
  }
  .contentBtns{
    margin-top: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    div{
      width: 10rem;
      height: 4rem;
      border-radius: 4px;
      line-height: 4rem;
      text-align: center;
      color: #fff;
      font-size: 1.4rem;
      cursor: pointer;
 
        background: #246DEB;
    }
  }
}
.type ::v-deep .el-dialog__wrapper{
  display: flex;
  align-items: center;
  margin-top: 0;
}
.clear ::v-deep .el-textarea__inner{
	resize: none;
  height: 15rem;
}
.imgs{
  display: flex;
  align-items: center;
}
.imgs img{
  width: 13.2rem;
  height: 9.6rem;
  border-radius: 4px;
  margin-right: 2rem;
}
.button{
  display: flex;
  align-items: center;
  justify-content: center;
}
.button div{
  width: 10rem;
  height: 4rem;
  border-radius: 4px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:nth-child(1){
    background: #D9D9D9;
  }
  &:nth-child(2){
    background: #246DEB;
    margin-left: 2rem;
  }
}
</style>